import { getTableData } from "@api/admin.js";
export default {
  data(){
    return {
      queryParam: {
        iDisplayStart: 0, //从第几条记录开始
        iDisplayIndex:0,  //默认显示的页数，从0开始
        iDisplayLength: 10, //查询的条数
        initOrderParam: '', //初始排序，用于table设置有排序状态时，点击排序时order为normal时调用
        currentPageNum: 1  //当前页码
      },
      tableData:[],  //表单数据
      totalRecords:0, //分页数据总数
      tableSelectedDatas: [], //表格已选项
      paasCurrentFunctionId:'', //功能id
      defaultModalTitle:'系统提示', //删除模态框title
      defaultDeleteModalContent:"确定要删除吗？", //删除模态框content
      opers:[], //操作
      noDataText:'', //table没数据的时候显示的图片
      defaultLabelWidth:100, //默认表单域标签的宽度,如果需要自定义，可以在FormItem设置label-width，否则继承 Form 组件的 label-width 的值
      tableOffsetTop:108, //相对高度，用于计算table高度
      defaultGetTabeleFun:"getTableData",
      tableHeight:0,  //初始化table默认高度，后面在mounted有运算
    }
  },
  created() {
    this.created();
  },
  methods: {
    created() {
      let funcId = this.$route.query.paasCurrentFunctionId;
      this.paasCurrentFunctionId = funcId;
      this.queryTableBeforeLogic();
      this.queryTableDatas();
    },
    /**
     * 查询之前组织查询参数
     */
    queryTableBeforeLogic(){

    },
    createdCallback() {

    },
    /**
     * 查询列表数据
     */
    queryTableDatas(param) {
      if(param) {
        this.queryParam.currentPageNum = 1;
        this.queryParam.iDisplayStart = 0;
        this.queryParam.iDisplayIndex = 0;
      }
      getTableData(this.serviceUrl+"/"+this.defaultGetTabeleFun, this.queryParam)
        .then(res => {
          console.log(res);
          console.log(this.queryParam);
          let data = res.data;
          //表单数据
          this.tableData = data.aaData;
          //根据table是否有
          if(this.tableData.length === 0 ){
            this.noDataText = '<img src="/image/no-data-img.png"/>'
          }
          //分页数据总数
          this.totalRecords = res.data.iTotalRecords;
          this.createdCallback();
      }).catch(err =>{
        this.$Message.error('数据查询失败，请重试！');
      });
    },
    /**
     * @on-selection-change，只要选中项发生变化时就会触发，返回值为 selection，已选项。
     */
    selectTableDataChange(selecttion){
      this.tableSelectedDatas = selecttion;
    },
    /**
     * @on-sort-change table排序时有效，当点击排序时触发 tableColumns里边有sortable: true，才有效
     * @param sort (column,key,order) order点击排序列状态顺序值：asc、desc、normal（恢复到开始状态）
     */
    sortTableData(sort) {
      //恢复到初始状态
      if(sort.order === "normal") {
        this.queryParam.queryOrderBy_ = this.queryParam.initOrderParam;
      }
      //asc、desc
      else {
        this.queryParam.queryOrderBy_ = sort.key+"@"+sort.order;
      }
      this.queryTableDatas();
    },
    /**
     * 增、删、改、查
     * */
    /**
     * 添加按钮
     * */
    paasAddPage(event, url) {
      if(!url) {
        url = this.serviceUrl+'/edit';
      }
      this.$router.push({'path':this.setUrlFuncId(url)});
    },
    /**
     * toolbar修改按钮
     * */
    paasEidtPage(url) {
      let selectedDatas = this.tableSelectedDatas;
      if(selectedDatas.length !== 1) {
        this.$Message.warning('请选择要修改的数据！');
      }
      else if(selectedDatas.length > 1){
        this.$Message.warning('请选择一行进行修改！');
      }
      else {
        this.paasEditOper(selectedDatas[0][this.currentIdFiledName],url);
      }
    },
    /**
     * 修改，参数是主键id对应的值，也适用于表单内修改操作
     * */
    paasEditOper(data, url) {
      if(!url) {
        url = this.serviceUrl+'/edit';
      }
      if(url.indexOf("?") !== -1) {
        url += '&'+this.currentIdFiledName+"="+data;
      } else {
        url += "?"+this.currentIdFiledName+"="+data;
      }
      this.$router.push({'path': this.setUrlFuncId(url)});
    },
    /**
     * 删除模态框
     */
    paasDeleteConfirmModel(title,content,id){
      let modalTitle = this.defaultModalTitle;
      let modalContent = this.defaultDeleteModalContent;
      if(title){
        modalTitle = title;
      }
      if(content){
        modalContent = content;
      }
      this.$Modal.confirm({
        title: modalTitle,
        content: modalContent,
        onOk: () => {
          this.paasConfirmDelete(id);
        },
        onCancel: () => {
          this.$Message.info('取消模态框');
        }
      });
    },
    /**
     * toolbar 删除按钮
     * */
    paasDeleteTableData() {
      let selectedDatas = this.tableSelectedDatas;
      if(selectedDatas.length === 0) {
        this.$Message.info('请选择要删除的数据！');
      }
      else {
        this.paasDeleteConfirmModel("","");
      }
    },
    /**
     * 表单内删除操作
     */
    paasDeleteOper(data){
      this.paasDeleteConfirmModel("","",data);
    },
    /**
     * 点击模态框的确定删除
     * */
    paasConfirmDelete(id){
      //表头删除
      let ids = "";
      if(!id){
        let selectedDatas = this.tableSelectedDatas;
        for(let i = 0; i < selectedDatas.length; i++) {
          if(ids) {
            ids += ",";
          }
          ids += selectedDatas[i][this.currentIdFiledName];
        }
      }else{
        ids = id;
      }
      this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/delete?"+this.currentIdFiledName+"s="+ids).then(res=> {
        this.$Modal.remove();
        this.$Message.info('数据删除成功！');
        this.queryTableDatas("delete"); //删除后刷新数据
      }).catch(error=>{
        this.$Modal.remove();
        this.$Message.info('数据删除失败，请重试！');
      });
    },
    /**
     * 删除树节点
     * @param param
     */
    deleteTreeNode(param){
      this.$Modal.confirm({
        title: '系统提示',
        content: '删除操作将会把所有下级节点全部删除，确定要删除吗？',
        onOk: () => {
          this.paasDeleteNode(param.row[this.currentIdFiledName]);
        },
        onCancel: () => {
          this.$Modal.remove()
        }
      })
    },
    /**
     * 查看
     * */
    paasDetailPage() {
      let selectedDatas = this.tableSelectedDatas;
      if(selectedDatas.length !== 1) {
        this.$Message.warning('请选择要查看的数据！');
      }
      else if(selectedDatas.length > 1){
        this.$Message.warning('请选择一行进行查看！');
      }
      else {
        this.paasDetailOper(selectedDatas[0][this.currentIdFiledName]);
      }
    },
    /**
     * 查看，参数是主键id对应的值
     * */
    paasDetailOper(data, url) {
      if(!url) {
        url = this.serviceUrl+'/detail';
      }
      if(url.indexOf("?") !== -1) {
        url += '&'+this.currentIdFiledName+"="+data;
      } else {
        url += "?"+this.currentIdFiledName+"="+data;
      }
      this.$router.push({'path': this.setUrlFuncId(url)});
    },
    initPage(){
      this.queryParam.iDisplayStart = 0;
      this.queryParam.iDisplayIndex = 0;
      this.queryParam.currentPageNum = 1;
    },
    /**
     * 页码改变的回调，返回改变后的页码
     * @param currentPage
     */
    changePage (currentPage) {
      this.queryParam.iDisplayStart = (currentPage - 1) * this.queryParam.iDisplayLength;
      this.queryParam.iDisplayIndex = currentPage - 1;
      this.queryParam.currentPageNum = currentPage;
      this.queryTableDatas();
    },
    /**
     * 改变每页显示数量
     * @param pageSize
     */
    changePageSize (pageSize) {
      this.queryParam.iDisplayLength = pageSize;
      this.queryTableDatas();
    },
    /**
     * url添加功能ID参数,封装这个方法是以防功能配置也有传参数
     * */
    setUrlFuncId(url) {
      if(url.indexOf("?") !== -1) {
        url += '&';
      } else {
        url += '?';
      }
      //组装paasCurrentFunctionId=***
      url += this.$store.state.funcIdName+'='+this.$route.query[this.$store.state.funcIdName];
      return url;
    },
    /**
     * 数字控件NumSelect存在时
     */
    queryData(data){
      this.queryParam['query_LT_'+data.name] = data.upper;
      this.queryParam['query_GTE_'+data.name] = data.sub;
      //console.log(this.queryParam);
      this.queryTableDatas();
    },
    /**
     * 计算table的高度
     * @param flag
     */
    calculateTableHeight(flag){
      let docHeight = document.documentElement.clientHeight; //可见区域的高度
      /**
       * 只能是元组件才有的方法
       * 距离父组件的高度
       * @type {number}
       */
      let queryOffsetTop = 0;
      if(this.$refs.listWrap){
          queryOffsetTop = this.$refs.listWrap.getBoundingClientRect().top;
      }

      let queryHeight = 0;
      if(flag || typeof(flag) === 'undefined'){
        /**
         * 当前组件的高度，非元组件
         * @type {number}
         */
        if(typeof(this.$refs.queryForm) !== "undefined"){
          queryHeight = this.$refs.queryForm.$el.clientHeight;
        }
      }
      this.tableHeight = docHeight - queryOffsetTop - queryHeight - this.tableOffsetTop;
    },
    /**
     * 切换查询的收起和展开按钮计算table的高度
     * @param flag
     */
    paasCalculate(flag){
      this.$nextTick(() => {
        this.calculateTableHeight(flag);
      })
    },
    mountedCallback(){

    }
  },
  mounted(){
    this.$nextTick(() => {
      this.calculateTableHeight();
      this.mountedCallback();
    })
  },
  watch:{
    $route(to,from){
      /**
       * 如果有配置keepAlive属性的说明需要缓存,而且只有这些路由到当前list路由需要缓存list的配置
       */
      if(this.keepAliveName){
        if(this.keepAliveName.indexOf(from.name) !== -1){
          to.meta.keepAlive = true;
        }else{
          to.meta.keepAlive = false;
        }

        if(this.keepAliveName.indexOf(to.name) !== -1){
          from.meta.keepAlive = true;
        }else{
          from.meta.keepAlive = false;
        }

      }
    }
  },
  /**
   * 这个功能是为了添加一条数据放在首条记录,
   * 修改更新数据
   */
  activated(){
    if(this.$route.meta.keepAlive){
      //通过路由获取的参数
      let updateData = this.$route.params.updateData;
      if(typeof(updateData) !== "undefined"){
        let isCreate = "yes"; //这个用于判断是新增还是修改，修改只更改内容，不添加数据
        if(updateData != null && updateData.length > 0){
          if(this.tableData != null && this.tableData.length > 0){
            for(let i=0;i<this.tableData.length;i++){
              //判断是新增还是修改
              //修改
              if(this.tableData[i][this.currentIdFiledName] === updateData[0][this.currentIdFiledName]){
                isCreate = "no";
                for(let key in this.tableData[i]){
                  this.tableData[i][key] = updateData[0][key];
                }
                break;
              }
            }
          }else{

          }
          //新增
          if(isCreate !== "no"){
            this.tableData.unshift(updateData[0]);  //向数组的开头添加一个或更多元素,并返回新的长度
            this.totalRecords = this.totalRecords + 1;
          }

          //如果长度大于查询的条数，则需要移除tableData最后一条数据
          if(this.tableData.length > this.iDisplayLength){
            this.tableData.pop(); //删除掉它的最后一个元素,返回最后一个元素值
          }
        }
      }
    }else{
      this.create();
    }

  },
}
